import axios from 'axios';
import toast from 'react-hot-toast';
import Cookies from 'universal-cookie';

axios.interceptors.response.use(null, (error) => {
  const expectedError =
    error.response && error.response.status >= 400 && error.response.status < 501;

  if (!expectedError) {
    toast.error('An unexpected error occurrred.');
  }

  if (error.response?.status === 401) {
    const cookies = new Cookies();
    cookies.remove('token', { path: '/' });
    window.location.href = ['DEVELOPMENT', 'STAGING'].includes(process.env.REACT_APP_STAGE)
      ? '/'
      : '/';
    toast.error('Maaf, sesi Anda telah berakhir, silakan login kembali.');
  }

  return Promise.reject(error);
});

// const CancelToken = axios.CancelToken;
// const source = CancelToken.source();

const actions = {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete
};

export default actions;
